import axios from "axios";
import { mapGetters } from "vuex";
import pdfIcon from '@/assets/images/pdf.png';
import docIcon from '@/assets/images/icon-doc.png';
import pptIcon from '@/assets/images/icon-ppt.png';
import pngIcon from '@/assets/images/icon-png.png';
import jpgIcon from '@/assets/images/icon-jpg.png';

export default {
  props: {
    answerId: Number
  },

  data() {
    return {
      answer: {},
      pdfIcon,
      docIcon,
      pptIcon,
      pngIcon,
      jpgIcon
    };
  },

  computed: {
    ...mapGetters(["teacherId", "schoolId", "studentId", "userType"]),
  },

  methods: {
    answerDetail() {
      axios.get("my/assignment/answer/detail/" + this.answerId)
        .then(response => {
          this.answer = response.data;
          this.answer.assignment_files.forEach(file => {
            const parts = file.path.split('.');
            let ext = '';
            if (parts.length > 1) {
              ext = parts.pop().toLowerCase();
              ext = ext.split(/[?#]/)[0];
            }
            file.type = ext;
          });
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('/');
          }
          console.log("Assignment Detail API Error:", error);
        });
    },

    answerList() {
      this.$emit('changeSection', 'AssignmentAnswerList');
    },

    async download(index) {
      var file = this.answer.assignment_files[index];
      try {
        const response = await axios.get(`/my/assignment/answer/download/${this.answerId}/${file.file_code}`, {
          responseType: "blob",
        });

        const blob = new Blob([response.data], { type: response.headers['content-type'] });
        const link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.download = file.name;
        link.click();
        URL.revokeObjectURL(link.href);
      } catch (error) {
        this.$notification.error("Download Failed.", {
          timer: 3,
          position: "bottomCenter",
        });
      }
    }
  },

  mounted() {
    this.answerDetail();
  }
};
